/**
 * @typedef {object} MechanismChoice
 * @property {string} category - Taxonomy category key.
 * @property {string} title - The concrete mechanism (signal) title.
 */

/**
 * Build the Firestore payloads for a batch of mechanisms picked at once in the
 * navigator's "Werkzaam mechanisme toevoegen" flow.
 *
 * The upstream link is the load-bearing part: adding from a chain links each new
 * mechanism to the current activiteit, adding from the Overzicht board leaves it
 * unlinked (the user drags to connect). Same rule as createNode('mech') — pass
 * `activityId` only when the add is chain-linked.
 *
 * Returns payloads WITHOUT `docid`/`ID`; the caller mints those from the
 * Firestore ref and a uuid.
 *
 * @param {object} params
 * @param {Array<MechanismChoice>} params.choices - What the user ticked.
 * @param {string | null} [params.activityId] - Activiteit ID to link to, or null/undefined for an unlinked add.
 * @param {number} params.startPosition - Position for the first doc; the rest follow in order.
 * @param {string} params.client - Tenant CompagnyID.
 * @param {*} params.timestamp - Firestore timestamp value.
 * @returns {Array<object>} One payload per choice, in the order they were ticked.
 */
const buildMechanismDocs = ({ choices, activityId, startPosition, client, timestamp }) =>
    (choices || []).filter(Boolean).map((choice, i) => ({
        Title: choice.title,
        Category: choice.category,
        Description: '',
        Activity: activityId ? [activityId] : [],
        Effect: [],
        Position: startPosition + i,
        Compagny: client,
        CompagnyID: client,
        Timestamp: timestamp,
    }))

export default buildMechanismDocs
